import DocInfo from "./DocInfo";

export default DocInfo;
